import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { LogOut, UserRound } from 'lucide-react'
import { useState } from 'react'

import { ApiError } from '@/lib/api'
import { esquecerSessao, sair, useSessao } from '@/lib/sessao'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

/*
 * O chip da pessoa no cabeçalho: nome e cargo sobre o azul-escuro, como no
 * protótipo do PO. É o gatilho de um menu com "Minha conta" (a troca de senha e
 * o e-mail para recuperação, para todo cargo) e "Sair": a sessão é invalidada
 * no servidor e a pessoa volta para a entrada. Sem sessão, não aparece.
 */
export function ChipSessao() {
  const { data: sessao } = useSessao()
  const queryClient = useQueryClient()
  const navegar = useNavigate()
  const [falhou, setFalhou] = useState(false)

  if (!sessao) return null

  async function aoSair() {
    setFalhou(false)
    try {
      await sair(queryClient)
    } catch (erro) {
      // 401: a sessão já tinha caído, então a pessoa já está fora.
      if (erro instanceof ApiError && erro.status === 401) {
        esquecerSessao(queryClient)
      } else {
        setFalhou(true)
        return
      }
    }
    await navegar({ to: '/gestor' })
  }

  return (
    <div className="relative flex-none">
      <DropdownMenu>
        <DropdownMenuTrigger
          data-slot="chip-sessao"
          className={
            'flex h-9 max-w-28 cursor-pointer flex-col items-start justify-center rounded-lg px-3 text-left ' +
            'bg-(--gef-azul-900) text-inverse sm:max-w-56'
          }
        >
          <span className="max-w-full truncate text-sm leading-tight font-bold">{sessao.nome}</span>
          <span className="max-w-full truncate text-2xs leading-tight font-medium">
            {sessao.cargo}
          </span>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="[--gef-foco:var(--gef-azul-600)]">
          <DropdownMenuItem onSelect={() => void navegar({ to: '/gestor/conta' })}>
            <UserRound aria-hidden="true" />
            Minha conta
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={() => void aoSair()}>
            <LogOut aria-hidden="true" />
            Sair
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      {falhou && (
        <p
          role="alert"
          className="absolute top-full right-0 z-10 mt-1 w-56 rounded-lg bg-destructive-soft px-3 py-2 text-sm text-destructive"
        >
          Não foi possível sair agora. Tente de novo.
        </p>
      )}
    </div>
  )
}
